<template lang="pug">
div
  //- | v-select(:value="item.status" :items="statusItems" @input="")
  v-card.mb-3
    v-card-title
      v-menu(:value="showMenu" @input="showMenu = $event" offset-y)
        v-btn(slot="activator") Formulare
        v-list
          template(v-for="formular in formulare")
            v-list-tile(@click="formData = formular"): v-list-tile-title {{formular.name}}
      .title {{formData && formData.name}}
    v-card-text(v-if="formData")
      v-data-table(:items="entries" :headers="headers" :loading="$apollo.queries.formEntries.loading")
        template(slot="items" slot-scope="{item}")
          tr
            td {{item.id}}
            td {{item.status}}
            template(v-for="field in indexFields")
              td(v-if="field.type === 'user_or_name_and_email'") {{userOrNameAndEmail(item)}}
              td(v-else-if="field.type === 'checkbox'") {{item[field.slug] ? 'Ja' : 'Nein'}}
              td(v-else-if="field.type === 'text'")
                template(v-if="(item[field.slug] || '').length > 50")
                  | {{item[field.slug].slice(0, 50) || '' }}
                  v-menu(offset-x)
                    v-btn(slot="activator") Mehr
                    v-card(max-width="700"): v-card-text.text-wrap-lines {{item[field.slug] || '' }}
                template(v-else) {{item[field.slug] || '' }}
              td(v-else) {{item[field.slug] || ''}}

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'

const FormEntryFields = gql`
  fragment FormEntryFields on FormEntry {
    fields {
      ... on  FormEntryFieldString {
        slug
        string
      }
      ... on FormEntryFieldBoolean {
        slug
        boolean
      }
      ... on FormEntryFieldInteger {
        slug
        integer
      }
      ... on FormEntryFieldFloat {
        slug
        float
      }
      ... on FormEntryFieldDate {
        slug
        date
      }
      ... on FormEntryFieldDateTime {
        slug
        datetime
      }
      ... on FormEntryFieldNone {
        slug
      }
    }
  }`

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      showMenu: false,
      formData: null,
    }
  },
  apollo: {
    currentUser: {
      query: gql`{
        currentUser {
          id
          formulare {
            id
            slug
            name
            fields
          }
        }
      }`
    },
    formEntries: {
      query: gql`query ($formId: ID!) {
        formEntries(formId: $formId) {
          id
          status
          user {
            id
            vorname
            nachname
            email
          }
          ...FormEntryFields
        }
      }
      ${FormEntryFields}
      `,
      variables() {
        return {
          formId: this.formData.id
        }
      },
      skip() {
        return !this.formData || !this.formData.id
      }
    }
  },
  watch: {
    formulare: {
      immediate: true,
      handler(neu, alt) {
        if (!alt) {
          this.showMenu = false
          this.$nextTick(() => {
            this.showMenu = true
          })
        }
      }
    }
  },
  computed: {
    statusItems() {
      return [{ text: 'Neu', value: 'Neu' }, { text: 'Bearbeitet', value: 'Bearbeitet' }]
    },
    formulare() {
      return this.currentUser && this.currentUser.formulare || []
    },
    formDefinition() {
      return this.formData && this.formData.fields && JSON.parse(this.formData.fields) || {}
    },
    entries() {
      if (!this.formData || !this.formData.id || !this.formEntries) {
        return []
      }
      return this.formEntries.map(data => {
        const fields = this.fields
        const entry = { id: data.id, status: data.status }
        data.fields.forEach(field => {
          if (field.slug === 'userId') {
            entry['user'] = data.user
          } else {
            const type = fields[field.slug] || {}
            switch (type.as) {
              case 'checkbox':
                entry[field.slug] = field.boolean
              break;
              case 'rating':
                entry[field.slug] = field.integer
              break;
              case 'text':
              default:
                entry[field.slug] = field.string
            }
          }
        })
        return entry
      })
    },
    indexFields() {
      const fieldNames = this.formDefinition.indexFields || this.form || []
      const types = this.fields
      const fields = []
      fieldNames.forEach(field => {
        if (field === 'user_or_name_and_email') {
          fields.push({ ...types[field], type: 'user_or_name_and_email' })
        } else {
          fields.push({ ...types[field], slug: field, type: (types[field] || {}).as })
        }
      })
      return fields
    },
    headers() {
      return [{ indexLabel: 'ID' }, { indexLabel: 'Status' }].concat(this.indexFields).map(type => {
        return { text: type.indexLabel || type.label || type.slug || '', sortable: false }
      })
    },
    form() {
      return this.formDefinition.form
    },
    fields() {
      return this.formDefinition.fields
    },
  },
  methods: {
    userOrNameAndEmail(entry) {
      if (entry.user) {
        const user = entry.user
        return `${user.vorname || ''} ${user.nachname || ''} ${user.email || ''}`
      } else {
        return `${entry.vorname || ''} ${entry.nachname || ''} ${entry.email || ''}`
      }
    },
  }
}
</script>
